import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlogCard from './components/BlogCard';
import {
  BlogPage,
  BlogContainer,
  BlogHeader,
  BlogPreTitle,
  BlogTitle,
  BlogSubtitle,
  PostGrid,
  EmptyState,
  LoadingWrap,
  CategoriaRow,
  CategoriaPill,
} from './styles/BlogStyles';
import {
  getPostsByCategoria,
  getAllCategorias,
  getCategoriaLabel,
} from '../services/blogService';
import { MF_BASE } from '../basePath';

export default function BlogCategoryPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  const label = getCategoriaLabel(slug);

  useEffect(() => {
    document.title = `${label} | Blog MF Real Estate`;
    const meta =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const m = document.createElement('meta');
        m.name = 'description';
        document.head.appendChild(m);
        return m;
      })();
    meta.content = `Artigos da categoria ${label} no blog da MF Real Estate.`;
  }, [label]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    (async () => {
      const [postsData, catsData] = await Promise.all([
        getPostsByCategoria(slug),
        getAllCategorias(),
      ]);
      if (!active) return;
      setPosts(postsData);
      setCategorias(catsData);
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, [slug]);

  return (
    <BlogPage>
      <Navbar />

      <BlogContainer>
        <BlogHeader>
          <BlogPreTitle>Categoria</BlogPreTitle>
          <BlogTitle>{label}</BlogTitle>
          <BlogSubtitle>
            {posts.length} artigo{posts.length === 1 ? '' : 's'} nesta categoria.
          </BlogSubtitle>

          {categorias.length > 0 && (
            <CategoriaRow>
              <CategoriaPill
                href={`${MF_BASE}/blog`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`${MF_BASE}/blog`);
                }}
              >
                Todos
              </CategoriaPill>
              {categorias.map((cat) => (
                <CategoriaPill
                  key={cat.slug}
                  $active={cat.slug === slug}
                  href={`${MF_BASE}/blog/categoria/${cat.slug}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`${MF_BASE}/blog/categoria/${cat.slug}`);
                  }}
                >
                  {getCategoriaLabel(cat.slug)} ({cat.count})
                </CategoriaPill>
              ))}
            </CategoriaRow>
          )}
        </BlogHeader>

        {loading && <LoadingWrap>Carregando…</LoadingWrap>}

        {!loading && posts.length === 0 && (
          <EmptyState>
            <h3>Nenhum artigo nesta categoria</h3>
            <p>Volte em breve.</p>
          </EmptyState>
        )}

        {!loading && posts.length > 0 && (
          <PostGrid>
            {posts.map((post, i) => (
              <BlogCard key={post.id} post={post} index={i} />
            ))}
          </PostGrid>
        )}
      </BlogContainer>

      <Footer />
    </BlogPage>
  );
}
